module.exports = __webpack_public_path__ + "static/media/e9.4088bd3b.jpg";